import { useRef, useState } from 'react';
import GoogleMap from 'google-maps-react-markers';

import { Marker } from '@/atoms';

import type { FunctionComponent } from 'react';
import type { TypeMapProps } from './types';

/**
 * Map
 */
export const Map: FunctionComponent<TypeMapProps> = ({
  className = '',
  location,
  defaultZoom = 14,
  minHeight,
}: TypeMapProps) => {
  const mapRef = useRef<google.maps.Map | null>(null);
  const [zoom, setZoom] = useState(defaultZoom);

  return (
    <GoogleMap
      apiKey={process.env.NEXT_PUBLIC_MAP_API_KEY ?? ''}
      defaultZoom={defaultZoom}
      defaultCenter={location}
      mapMinHeight={minHeight}
      options={{
        mapTypeControl: false,
        streetViewControl: false,
        fullscreenControl: false,
        disableDefaultUI: true,
        clickableIcons: false,
        zoom: zoom,
        mapId: process.env.NEXT_PUBLIC_MAP_ID_STYLESS ?? '',
      }}
      onGoogleApiLoaded={({ map }: { map: google.maps.Map }) => {
        mapRef.current = map;
        map.setOptions({
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
        });
      }}
      onChange={({ zoom }: any) => setZoom(zoom)}
      containerProps={{
        className: `w-full ${className}`,
      }}
    >
      <Marker lat={location.lat} lng={location.lng} />
    </GoogleMap>
  );
};

Map.displayName = 'Map';
